export const UPDATE_ROUTE_DATA = "MSEO/UPDATE_ROUTE_DATA";
export const FILTER_COLLAPSE  = "MSEO/FILTER_COLLAPSE";
export const UPDATE_SRP_BUS_DATA = "MSEO/UPDATE_SRP_BUS_DATA";
export const UPDATE_GO_SAFE_BANNER = "MSEO/UPDATE_GO_SAFE_BANNER";
export const UPDATE_ROUTE_ID = "MSEO/UPDATE_ROUTE_ID";
export const STORE_LEAVE_INTENT_DATA ="SEO/STORE_LEAVE_INTENT_DATA";